import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostFeldOptionCommandServiceModule } from '..';
import { PostFeldOptionCommandComponent } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
    PostFeldOptionCommandServiceModule
  ],
  declarations: [PostFeldOptionCommandComponent],
  exports: [PostFeldOptionCommandComponent],

})
export class PostFeldOptionCommandComponentModule { }
